export const m = {
    about: 'About',
    Qualification: 'Qualification',
    LegalDocument: 'Legal Document',
    Partners: 'Partners',
    ContactUs: 'Contact Us',
    Trade: 'Trade',
    IEO: 'IEO',
    OTC: 'OTC',
    News: 'News',
    Announcement: 'Announcement',
    IndustryNews: 'Industry News',
    Assets: 'Assets',
    Personalcenter: 'Personal center',
    logout: 'log out',
    login: 'Login',
    register: 'Register',
    Exchange: 'Exchange',
    LVOSubscribe: 'Subscribe',
    Notice: 'Notice',
    Tradingpair: 'Trading pair',
    Latestprice: 'Latest price',
    hChange: '24h Change',
    hHigh: '24h High',
    hLow: '24h Low',
    hVolume: '24h Volume',
    Deal: 'Deal',
    gBlockchain: 'Global Blockchain Assets Trading Platform',
    ReliableSystem: 'Reliable System',
    RelGuaranteestem: 'Guarantee the safe, stable and efficient operation of the transaction',
    Elitewor: 'Elite team of top talent in the world',
    Safetyfund: 'Safety of fund',
    encryption: 'Https data encryption, identity verification',
    encryptarchitectureion: 'Cold Wallet Storage, financial level architecture,multiple security protection',
    eexperienceon: 'The best experience',
    eeMultilingualn: 'Rapid withdrawals, Multilingual',
    Highperformance: 'High performance trading engine, fast trading experience',
    Professionalservices: 'Professional services',
    Professiinternational: 'Professional international service teams',
    problemsal: 'Respond to user problems in a timely manner',
    Anywhere: 'Trade. Anywhere.',
    cryptocurrencye: "All the power of Cornucopia's cryptocurrency exchange, in the palm of your hand. Download the Cornucopia mobile crypto trading app today.",
    cryTradingcye: "Start Trading",
    Deposi: "Deposit",
    Help: "Help",
    Registernow: "Register now",
    trading: "Start trading",
    Beginnerguide: "Beginner's guide",
    FAQ: "FAQ",
    FADigitalQ: "Introduction of Digital Assets",
    PrivacyPolicy: "Privacy Policy",
    Disclaimer: "Disclaimer",
    UserAgreement: "User Agreement",
    Mail: "Mail",
    Address: "Address",
    Unitedsta: "NY United States",
    UniDigitaltedsta: "Digital assets are innovative investment products with high price volatility and high investment risk. Before investing, please fully recognize digital assets, rationally judge their investment ability, and make prudent investment decisions.",
    Risktips: "Risk tips",
    COMMITTED: "WE ARE COMMITTED TO HELPING BOLCKCHAIN PROJECTS RAISE FUNDS FIND SUPPORTERS, AND MAKE FRESH AND INTERESTING GOOD IDEAS COME TRUE.",
    CURRENCY: "NEW CURRENCY RUSH",
    CURInformationNCY: "LVO -Token Information",
    CURInformatiFVG: "FVG -Token Information",
    CURInformatcvv: "CVV -Token Information",
    Circulation: "Circulation",
    Liquidity: "Liquidity",
    Initialprice: "Initial price",
    Lockcycle: "Lock cycle",
    Deadline: "Deadline",
    DeaSubscrip: "Subscription countdown",
    Subscribe: "Subscribe",
    SessionTicket: "LVO - USDT SessionTicket Claim in Progress",
    SOperatingt: "LVO- The Operating System for DApps",
    Price: "Price",
    SessionSupply: "Session Supply",
    Sessipaper: "Download white paper",
    Requirements: "Requirements for participating in this token sale",
    Reqcompleteents: "All users must complete identity verification to meet the requirements of this project",
    Pleaseents: "Please login first",
    ProjectIntroduction: "Project Introduction",
    Keyfeatures: "Key features",
    Purposeof: "Purpose of",
    TOKENALLOCATION: "TOKEN ALLOCATION",
    TOKENSCHEDULE: "TOKEN RELEASE SCHEDULE",
    MyAssets: "My Assets",
    Withdrawhistory: "Deposit and Withdraw history",
    SubscribeHistory: "Subscribe History",
    Capitalflow: "Capital flow",
    Deposit: "Deposit",
    TotalAssets: "Total Assets",
    Toconversionsets: "Note: Total assets conversion is estimated by market quotation, which only provides a reference for users",
    SmallBalances: "Small Balances",
    Currency: "Currency",
    Total: "Total",
    Available: "Available",
    Frozen: "Frozen",
    Description: "Description",
    Withdraw: "Withdraw",
    WithdrawAddress: "Withdraw Address",
    WithdrawAmount: "Withdraw Amount",
    ServiceCharge: "Service Charge",
    Amountarrival: "Amount of arrival",
    fundpwd: "fund-pwd",
    Tips: "Tips",
    minimum: "The minimum withdrawal amount is",
    musuallyum: "Withdrawal usually takes 2-24 hours to complete the account, and you will be notified by email after arrival In order to ensure the safety of funds, when your account security policy changes, password changes, or use new addresses to withdraw money, we will conduct a manual review. Please be patient and wait for the staff to contact by phone or email.",
    muconfirmyum: "Be sure to confirm the security of your computer and browser to prevent information from being tampered with or leaked.",
    forbiddenum: "It is forbidden to deposit and withdraw digital currency between accounts on the Cornucopia platform. ",
    DepositAddress: "Deposit Address",
    Copy: "Copy",
    blockchainCopy: "I have deposited，please check the blockchain",
    confirmnCopy: "Be sure to confirm the security of your computer and browser to prevent information from being tampered with or leaked.",
    forbidden: "It is forbidden to deposit and withdraw digital currency between accounts on the Cornucopia platform.",
    Type: "Type",
    Startt: "Start Time",
    EndTime: "End Time",
    QUERY: "QUERY",
    Amount: "Amount",
    Balance: "Balance",
    Time: "Time",
    Status: "Status",
    Commissions: "Commissions",
    Blockchainid: "Blockchain id",
    Ins: "Ins",
    TotalValue: "Total Value",
    newcurrency: "New currency in hot subscription",
    Tokeninformation: "Token information",
    Day: "Day",
    Dsubscriptionay: "Your subscription",
    Pleaseonay: "Please enter the Curency",
    availablebalance: "available balance",
    All: "All",
    SUBMIT: "SUBMIT",
    SUWelcomeBMIT: "Welcome back, please enter your user information",
    Account: "Account",
    Password: "Password",
    ForgetPassword: "Forget Password",
    notForaccount: "Do not have an account",
    Signnow: "Sign up now",
    Welcomejois: "Welcome to join us",
    Phone: "Phone",
    Email: "Email",
    Nationality: "Nationality",
    LoginPassword: "Login Password",
    ConfirmPassword: "Confirm Password",
    VerificationCode: "Verification Code",
    InvitationCode: "Invitation Code",
    Ihavereae: "I have read the",
    Useragreement: "User agreement",
    Existingaccount: "Existing account",
    Loginimmediately: "Login immediately",
    BasicInformation: "Basic Information",
    MyAccount: "My Account",
    Nickname: "Nickname",
    Change: "Change",
    UserID: "User ID",
    FundPassword: "Fund Password",
    FResetssword: "Reset fund password",
    Noteoriginal: "Note: The original fund password will be discarded after reset, and the new password will be used for transactions",
    DoubleAuthentication: "Double Authentication",
    Bind: "Bind",
    Edit: "Edit",
    Verification: "Verification",
    licensetype: "license type",
    name: "name",
    licensenumber: "license number",
    PaymentAccount: "Payment Account",
    Add: "Add",
    Apaymentdd: "You have not set up any payment account",
    Delete: "Delete",
    LoginHistory: "Login History",
    Loginmethod: "Login method",
    IP: "IP",
    Riskdisclosurebook: "Risk disclosure book",
    chinaz: "English",
    LatestNews: "Latest News",
    updatesnse: "Real-time updates, First-hand information, First-second interpretation",
    Curency: "Curency",
    Curplatformency: "The world's top comprehensive trading platform",
    digitalency: "Trading CFD in a safe, fair and transparent environment",
    coinsency: "The best place to trade CFD",
    coIntegrationency: "Integration of Finance and Technology",
    basictionency: "Powerful basic financial and transaction infrastructure, adopting multi-layer and multi-cluster system architecture, greatly improving the security and stability of the system, AI technology and micro-service split design and application, intelligently improving transaction safety factor",
    bandency: "Fast and concise trading platform",
    basystemcy: "Megabit memory matching system, accurate and fast transaction order execution, low latency of core transactions",
    eliteemcy: "Professional elite team",
    capabiqlities: "Practitioners in the top blockchain, finance and AI fields create a professional team with strong rapid development capabilities for new and personalized businesses, and provide 7*24 hours of multilingual customer service support",
    fairities: "Safe, fair and transparent trading environment",
    regulatoryties: "Holds financial regulatory licenses from multiple countries, and obtains the U.S. Department of Treasury's Digital Ratio Trading License",
    CFDtrading: "CFD trading",
    CFDtmajorng: "Trading major active markets and varieties such as cryptocurrencies with relatively low margin and fees.",
    ICOransaction: "ICO transaction",
    Supportmajorng: "Support currency exchange transactions of the world's mainstream cryptocurrencies",
    OTCansaction: 'OTC transaction',
    otcajorng: 'Support foreign currency exchanges with mainstream cryptocurrencies',
    Blockchnsaction: 'Blockchain wallet',
    Blockchjorng: 'Use blockchain decentralization technology to realize safe management of assets and convenient circulation',
    Beginorng: 'Begin trading on VMISL immediately',
    LetBeginorng: 'Let the transaction worry more at ease',
    LOpeninorng: 'Open account',
    stableorng: 'Fast and stable trading platform',
    sPlcgGObleorng: 'VMtrade is the first choice for ordinary investors',
    sPSimpleeorng: 'Simple, fast and easy to use platform, all varieties at your fingertips.VMtrade is a web-based application, suitable for PC or mobile web login transactions.',
    ssuitableng: 'VMtrade is suitable for all investors',
    pWerovide: 'We provide a trading platform that can be downloaded and installed on PC or mobile terminal. No matter where you are, you can download and install the trading platform for trading.',
    accountide: 'Select an account and submit your application',
    cardInvest: 'Transfer money quickly by debit or bank cardInvest safely.',
    Accesswr: 'Access transaction types and methods such as contract for difference.',
    Acinvestmentsswr: 'The value of your investments may go up or down. In margin trading, it is possible to lose more than the margin or even a large portion of the principal. High leverage means high risk, and you should carefully consider your risk tolerance and understanding of leveraged trading.',
    Arealizetsswr: 'You must realize that risks include not only trading risks, but also risks caused by force majeure factors, such as network disruption, political unrest, hacker attacks, etc.',
    Parklifetsswr: 'Vmisl (China Vision capital (Hong Kong) Limited) is regulated by SFC securities and Futures Commission, with license No. bii154 and query link https://apps.sfc.hk/publicregWeb/searchByName?locale=zh',
    drtwebfetsswr: 'This website is accessible worldwide. All information on this website is for reference only and does not constitute guidance advice. We shall not be liable for any consequences arising from the actions or omissions of anyone acting on this website or the information contained on this website.',
    webfetsswr: 'Download APP Start trading',
    home: 'Home',

    // 东盛新增
    selectsown: 'Please select your download method',
    downffgdr: 'Local download',    
    downfsafgdr: 'Code scanning Download',
    Qualification:'Qualification',
    licenseTitle: 'Supervised by SFC securities and Futures Commission',
    licenseNumber: 'License number',
    licenseLink: 'Query link',
    homeTheMost:'The most trusted financial derivatives trading platform',
    viewCertificate:'View Certificate',
}


// WEBPACK FOOTER //
// ./src/common/lang/en.js